const $$splitComponentImporter = () => import('/data/circle/current/app/javascript/react/tanstack_routes/_protected/_settingsLayout/settings/courses/$id/edit.tsx?tsr-split=component');
import { lazyRouteComponent } from '@tanstack/react-router';
import { CUSTOMIZE_SPACE_TABS } from "@circle-react/constants/spaces/customizeSpaceTabs";
import { createFileRoute } from "@tanstack/react-router";
import { z } from "zod";
const editCourseSearchSchema = z.object({
  tab: z.enum(CUSTOMIZE_SPACE_TABS).optional().catch(undefined),
  page: z.coerce.number().optional().catch(undefined),
  status: z.string().optional().catch(undefined),
  workflow_type: z.string().optional().catch(undefined),
  scrollToId: z.string().optional().catch(undefined)
});
export const Route = createFileRoute("/_protected/_settingsLayout/settings/courses/$id/edit")({
  validateSearch: editCourseSearchSchema,
  component: lazyRouteComponent($$splitComponentImporter, 'component')
});